"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Utils_1 = require("@becrop/components/Map/Utils");
class Field {
    constructor(fieldConfig) {
        this.id = fieldConfig.id;
        this.gfId = fieldConfig.gfId;
        this.fieldName = fieldConfig.fieldName;
        this.geodata = fieldConfig.geodata;
        this.farmId = fieldConfig.farmId;
        this.farmName = fieldConfig.farmName;
        this.size = Math.round(fieldConfig.size * 100) / 100;
        this.sizeUnit = 'acres';
        this.crop = fieldConfig.crop;
        this.managementPractice = fieldConfig.managementPractice;
        this.origin = fieldConfig.origin;
        this.metadata = fieldConfig.metadata;
        this.advancedMetadata = fieldConfig.advancedMetadata;
        this.projection = fieldConfig.projection || 'EPSG: 4326';
        this.quoteId = fieldConfig.quoteId;
        this.ebecrop = fieldConfig.ebecrop || false;
        this.hasBeenValidated = fieldConfig.hasBeenValidated || false;
        this.fillAdvancedMetadata();
        this.closeToFarm = true;
        this.editionData = fieldConfig.editionData;
        this.provider = fieldConfig.provider || '';
        this.providerFieldId = fieldConfig.providerFieldId || '';
    }
    initEdition() {
        this.editionData = {
            editing: true,
            history: {
                name: this.fieldName,
                metadata: this.advancedMetadata,
                crop: this.crop,
                geodata: this.geodata,
                management: this.managementPractice
            }
        };
    }
    cancelEdition() {
        this.fieldName = this.editionData.history.name;
        this.crop = this.editionData.history.crop;
        this.metadata = this.editionData.history.metadata;
        this.managementPractice = this.editionData.history.management;
        this.geodata = this.editionData.history.geodata;
        this.finishEdition();
    }
    finishEdition() {
        this.editionData = {
            editing: false,
            history: this.editionData.history
        };
    }
    fillAdvancedMetadata() {
        if (!this.advancedMetadata) {
            this.advancedMetadata = {
                extension: {
                    value: this.size,
                    unit: this.sizeUnit
                },
                practices: {
                    artificial_irrigation: {
                        enabled: false,
                    },
                    biodynamic_practices: {
                        enabled: false
                    },
                    management_practices: []
                }
            };
        }
    }
    setProjection(newProjection) {
        this.projection = newProjection;
    }
    setGeodata(newGeodata) {
        this.geodata = newGeodata;
    }
    setCrop(crop) {
        this.crop = crop;
    }
    setManagementPractice(practice) {
        var _a;
        this.managementPractice = practice;
        if (this.advancedMetadata) {
            if ((_a = this.advancedMetadata.practices.management_practices) === null || _a === void 0 ? void 0 : _a.length) {
                this.advancedMetadata.practices.management_practices = [];
                this.advancedMetadata.practices.management_practices.push(practice.id);
            }
            else {
                this.advancedMetadata = Object.assign(Object.assign({}, this.advancedMetadata), { practices: {
                        artificial_irrigation: Object.assign({}, this.advancedMetadata.practices.artificial_irrigation),
                        biodynamic_practices: Object.assign({}, this.advancedMetadata.practices.biodynamic_practices),
                        management_practices: []
                    } });
                this.advancedMetadata.practices.management_practices.push(practice.id);
            }
        }
        else {
            this.advancedMetadata = {
                extension: {
                    value: this.size,
                    unit: this.sizeUnit
                },
                practices: {
                    artificial_irrigation: {
                        enabled: false,
                    },
                    biodynamic_practices: {
                        enabled: false
                    },
                    management_practices: []
                }
            };
            this.advancedMetadata.practices.management_practices.push(practice.id);
        }
    }
    updateSize() {
        let extension = (0, Utils_1.getExtension)(this.geodata); // Asumimos que esto da un valor en hectáreas.
        // Si la unidad es hectáreas, usamos el valor tal cual.
        if (this.sizeUnit === "hectares") {
            this.size = Math.round((extension / 10000) * 100) / 100; // Dividir entre 10000 para convertir de m² a hectáreas.
        }
        // Si la unidad es acres, convertimos de hectáreas a acres (1 hectárea = 2.47105 acres).
        else if (this.sizeUnit === "acres") {
            this.size = Math.round((extension / 4046.86) * 100) / 100; // Convertir de hectáreas a acres.
        }
    }
    setName(newName) {
        this.fieldName = newName;
    }
    setFarmName(newName) {
        this.farmName = newName;
    }
    setAcreageUnit() {
        this.sizeUnit === 'hectares' ? this.sizeUnit = "acres" : this.sizeUnit = "hectares";
        this.updateSize();
    }
    evaluateFieldDistance(farmGeodata) {
        this.closeToFarm = (this.areEntitiesCloseAndSameCrop(farmGeodata)) ? true : false;
    }
    parseGeodataToCoordinates(geodata) {
        const match = geodata.match(/\(\((-?[0-9.]+) (-?[0-9.]+)/);
        if (!match)
            throw new Error('Invalid geodata format');
        return [parseFloat(match[1]), parseFloat(match[2])];
    }
    areEntitiesCloseAndSameCrop(farmGeodata) {
        const MAX_DISTANCE_KM = 25;
        const [lon1, lat1] = this.parseGeodataToCoordinates(farmGeodata);
        const [lon2, lat2] = this.parseGeodataToCoordinates(this.geodata);
        const distance = this.calculateDistance(lat1, lon1, lat2, lon2);
        return distance <= MAX_DISTANCE_KM;
    }
    calculateDistance(lat1, lon1, lat2, lon2) {
        const R = 6371;
        const toRad = (angle) => angle * (Math.PI / 180);
        const dLat = toRad(lat2 - lat1);
        const dLon = toRad(lon2 - lon1);
        const a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
                Math.sin(dLon / 2) * Math.sin(dLon / 2);
        const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
        return R * c;
    }
}
exports.default = Field;
